module.exports = __webpack_public_path__ + "static/media/ASCBN-TITLE-HORIZONTAL-LIGHT-TRANSPARENT.cf741508.png";